import * as React from "react";
import styled from "styled-components";
import { useLightboxContext } from "../context";
const _LightboxAspectRatio = ({ children, ...props }) => {
    useLightboxContext("LightboxFrame");
    return (React.createElement("div", { "data-testid": "aspect-ratio", ...props }, children));
};
const arBoxWidth = `calc(100vw - (var(--ar-box-horizontal-gutters) * 2))`;
export const LightboxAspectRatio = styled(_LightboxAspectRatio) `
  /**
   * gutter size is Responsive
   */
  --ar-box-gutter-size: 24px;
  @media (min-width: 600px) {
    --ar-box-gutter-size: 32px;
  }

  --ar-box-horizontal-gutters: 0px;
  --ar-box-vertical-gutters: var(--ar-box-gutter-size);
  /* aspect ratio media queries ensure that the container never colides with lightbox close button. */
  @media (min-aspect-ratio: ${({ width, height }) => `${(width / height) * 0.9}`}) {
    --ar-box-horizontal-gutters: var(--ar-box-gutter-size);
  }
  /* note that between these 2 aspect ratios, the ar-box will have both vertical and horizontal gutters. */
  @media (min-aspect-ratio: ${({ width, height }) => `${(width / height) * 1.1}`}) {
    --ar-box-vertical-gutters: 0px;
  }

  width: ${arBoxWidth};
  height: ${({ width, height }) => {
    return `calc(${height / width} * ${arBoxWidth})`;
}};
  --max-ar-box-height: calc(100vh - (var(--ar-box-vertical-gutters) * 2));
  max-height: var(--max-ar-box-height);
  max-width: ${({ width, height }) => {
    return `calc(${width / height} * var(--max-ar-box-height))`;
}};

  margin: auto;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  top: var(--ar-box-vertical-gutters);
  bottom: var(--ar-box-vertical-gutters);
  left: var(--ar-box-horizontal-gutters);
  right: var(--ar-box-horizontal-gutters);
`;
//# sourceMappingURL=LightboxAspectRatio.js.map